import $ from 'jquery';
window.$ = $;

import 'bootstrap'

// import 'js-cookie'

// Fonts
import '@fortawesome/fontawesome-free'
// import "@fontsource/open-sans"

// ideally, this would be split off and only loaded when needed:
import 'chart.js';

// require ('./js/argon.js')
import './js/argon.js'

import './scss/argon.scss'

// $('.navbar-brand-img').hide();

